export default class ResetPasswordService {
    /* @ngInject */
    constructor(apiService) {
        this.apiService = apiService;
    }

    send(email) {
        return this.apiService.post(`/password/send-reset-email`, {
            email
        }, {
            anonymous: true
        });
    }

    validate(token) {
        return this.apiService.post(`/password/validate-reset-token`, {
            token
        }, {
            anonymous: true
        });
    }

    reset(token, password) {
        return this.apiService.post(`/password/reset`, {
            token,
            password
        }, {
            anonymous: true
        });
    }
}



// WEBPACK FOOTER //
// ./src/application/scene/identity/scene/forgot-password/service/reset-password.service.js